<mat-toolbar [ngStyle]="colorButtonBackground">
  <div class="container">
    <div class="row text-white py-2 py-md-3">
      <app-user-info></app-user-info>
    </div>
  </div>
</mat-toolbar>
  <div class="bg-light-darker1 height-3px"></div>
  
